import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { toast } from 'react-toastify';

const AddStaffReportModal = ({ open, onClose, onSubmit }) => {
    const [phoneList, setPhoneList] = useState('');
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        if (open) {
            setPhoneList('');
        }
    }, [open]);

    const handleSubmit = () => {
        const phones = phoneList
            .split(',')
            .map((phone) => phone.trim())
            .filter((phone) => phone !== '');

        if (phones.length === 0) {
            toast.error('Vui lòng nhập ít nhất một số điện thoại.');
            return;
        }

        onSubmit(phones);
    };

    const handleClose = () => {
        setPhoneList('');
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            fullScreen={isMobile} // Make dialog fullscreen on mobile
        >
            <DialogTitle>Nhập danh sách số điện thoại</DialogTitle>
            <DialogContent>
                <TextField
                    label="Danh sách số điện thoại (ngăn cách bằng xuống dòng)"
                    fullWidth
                    margin="normal"
                    multiline
                    rows={isMobile ? 5 : 8} // Adjust rows for mobile
                    value={phoneList}
                    onChange={(e) => setPhoneList(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Hủy</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
                    Thêm vào báo cáo
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddStaffReportModal;
